export enum FuelCardActionTypes {
  DOWNLOAD_TRANSACTIONS_REPORT_REQUEST = 'DOWNLOAD_TRANSACTIONS_REPORT_REQUEST',
  DOWNLOAD_TRANSACTIONS_REPORT_END = 'DOWNLOAD_TRANSACTIONS_REPORT_END',
  LOAD_FUEL_VEHICLES_REQUEST = 'LOAD_FUEL_VEHICLES_REQUEST',
  LOAD_FUEL_VEHICLES_SUCCEEDED = 'LOAD_FUEL_VEHICLES_SUCCEEDED',
  LOAD_FUEL_VEHICLES_FAILED = 'LOAD_FUEL_VEHICLES_FAILED',
  UPDATE_FUEL_VEHICLES_REQUEST = 'UPDATE_FUEL_VEHICLES_REQUEST',
  UPDATE_FUEL_VEHICLES_END = 'UPDATE_FUEL_VEHICLES_END',
}
